module.exports = __webpack_public_path__ + "img/acaki6.0f487032.jpg";